module.exports = __webpack_public_path__ + "img/popup-success-1.97191d89.png";